import {combineReducers} from 'redux';

import srpPageReducer from './pages/SRP/redux/reducers';
import offerWidgetReducer from './pages/SRP/offer-widget-redux/reducers';
import destinationsReducer from './pages/HomePage/destinations-redux/reducers';
import detailsPageReducer from '@stencil/hotels-details-reducer/src/reducer';
import commonReducer from '@stencil/hotels-common-reducer/src/reducers';

import homePageReducer from './pages/HomePage/redux/reducers';
import mapsReducer from './pages/HotelsMap/redux/reducer';
import {reviewReducer} from '@stencil/hotels-review-reducer';
import {smartEngageReducer} from '@stencil/hotels-smartengage-store';
import ugcReducer from '@stencil/hotels-ugc-redux/src/hotels-ugc-reducer';
import hotelsHolidayCalendarReducer from '@stencil/hotels-holiday-calendar-reducer/src/reducers';
import travellerDetailsReducer from '@stencil/hotels-travellers-form-reducer/src/reducers';

const reducerList = {
  srp: srpPageReducer,
  details: detailsPageReducer,
  common: commonReducer,
  home: homePageReducer,
  ugc: ugcReducer,
  offerWidget: offerWidgetReducer,
  smartEngage: smartEngageReducer,
  destinations: destinationsReducer,
  review: reviewReducer,
  maps: mapsReducer,
  holidayCalendar: hotelsHolidayCalendarReducer,
  travellerDetails: travellerDetailsReducer,
};

export default reducerList;

const rootReducer = combineReducers(reducerList);

export type AppState = ReturnType<typeof rootReducer>;
